module.exports = __webpack_public_path__ + "static/advantage-2-7165dbe30abbf3b0d8b8311c41bb6846.svg";